var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.pageLoading),expression:"pageLoading"}],staticClass:"examin"},[_c('img',{attrs:{"src":require("@/assets/images/videoResult.png")}}),_c('div',{staticClass:"examinText"},[_vm._v("交卷成功")]),_c('p',{staticClass:"text1"},[_vm._v("交卷成功2个工作日后可查看考试成绩")])])
}
var staticRenderFns = []

export { render, staticRenderFns }